import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@e2n/ui';

import { useFristenContext } from '@/domain/mitarbeiter/features/anlageassistent/content/Anstellungsverhaeltnis/Fristen/context/useFristenContext';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';

export function DeleteFristenDialog() {
  const { setOpenDeleteDialog, openDeleteDialog, fristIndex } =
    useFristenContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  const handleDelete = () => {
    form.removeFieldValue(`anstellungsverhaeltnis.fristen`, fristIndex);
    toast({
      title: t(
        'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.deleteFristDialog.message',
      ),
    });
    setOpenDeleteDialog(false);
  };
  return (
    <Dialog
      open={openDeleteDialog}
      onOpenChange={(open) => setOpenDeleteDialog(open)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-neutrals-900 text-xl font-bold leading-7">
            {t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.deleteFristDialog.title',
            )}
          </DialogTitle>
          <DialogDescription>
            {t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.deleteFristDialog.description',
            )}
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-4">
          <Button
            variant={'outline'}
            onClick={() => setOpenDeleteDialog(false)}>
            {t('actions.abbrechen')}
          </Button>
          <Button variant={'destructive'} onClick={handleDelete}>
            {t(
              'domain.mitarbeiter.create.steps.anstellungsverhaeltnis.fristen.deleteFristDialog.buttonLabel',
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
